import {formatTime} from '../../../../utilis/timeUtilis';
import type {ResolvedSegment} from './speakers';

export const transcriptToText = (segments: readonly ResolvedSegment[]): string =>
    segments
        .filter((segment) => segment.text)
        .map((segment) => `[${formatTime(segment.startTime)}] ${segment.speaker.name}: ${segment.text}`)
        .join('\n');

export const transcriptFileName = (callId: number, startedAt: string | null | undefined): string => {
    const date = startedAt ? startedAt.slice(0, 10) : 'unknown-date';
    return `call-${callId}-${date}.txt`;
};

export const downloadText = (fileName: string, text: string, type = 'text/plain;charset=utf-8'): void => {
    const url = URL.createObjectURL(new Blob([text], {type}));
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 0);
};
